import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import login from '@/components/login'
import register from '@/components/register'
import resetPwd from '@/components/resetPwd'
import mlogin from '@/components/mlogin'
import mregister from '@/components/mregister'
import mresetPwd from '@/components/mresetPwd'
import agreement from '@/components/agreement'
import control from '@/components/control'
import accBind from '@/components/index/accBind'
import bindList from '@/components/index/accBind/bindList'
import editPhone from '@/components/index/accBind/editPhone'
import safetyCenter from '@/components/index/safetyCenter'
import changePwd from '@/components/index/safetyCenter/changePwd'
import realNameCheck from '@/components/index/safetyCenter/realNameCheck'
import cancelAcc from '@/components/index/safetyCenter/cancelAcc'
import menberCenter from '@/components/index/menberCenter'
import commentMan from '@/components/index/commentMan'
import noPage from '@/components/404'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
            path: '/',
            redirect: '/index',
        }, {
            path: '/index',
            name: 'index',
            component: index,
            redirect: '/index/accBind',
            children: [{
                    path: '/index/accBind',
                    name: 'accBind',
                    component: accBind,
                    redirect: '/index/accBind/bindList',
                    children: [{
                        path: '/index/accBind/bindList',
                        name: 'bindList',
                        component: bindList,
                    }, {
                        path: '/index/accBind/editPhone',
                        name: 'editPhone',
                        component: editPhone,
                    }],
                },
                {
                    path: '/index/safetyCenter',
                    name: 'safetyCenter',
                    component: safetyCenter,
                    redirect: '/index/safetyCenter/changePwd',
                    children: [{
                        path: '/index/safetyCenter/changePwd',
                        name: 'changePwd',
                        component: changePwd,
                    }, {
                        path: '/index/safetyCenter/realNameCheck',
                        name: 'realNameCheck',
                        component: realNameCheck,
                    }, {
                        path: '/index/safetyCenter/cancelAcc',
                        name: 'cancelAcc',
                        component: cancelAcc,
                    }]
                },
                {
                    path: '/index/menberCenter',
                    name: 'menberCenter',
                    component: menberCenter,
                },
                {
                    path: '/index/commentMan',
                    name: 'commentMan',
                    component: commentMan,
                },
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: login
        },
        {
            path: '/register',
            name: 'register',
            component: register
        },
        {
            path: '/resetPassword',
            name: 'resetPwd',
            component: resetPwd
        },
        {
            path: '/center',
            name: 'center',
            redirect: '/index',
        },
        {
            path: '/mlogin',
            name: 'mlogin',
            component: mlogin
        },
        {
            path: '/mregister',
            name: 'mregister',
            component: mregister
        },
        {
            path: '/mresetPassword',
            name: 'mresetPwd',
            component: mresetPwd
        },
        {
            path: '/agreement',
            name: 'agreement',
            component: agreement
        },
        {
            path: '/control',
            name: 'control',
            component: control
        },
        {
            path: '/404',
            name: '404',
            component: noPage
        },
        // 404 page must be placed at the end !!!
        { path: '*', redirect: '/404', hidden: true }
    ],
    // IE9不支持Vue history路由模式，改成false
    fallback: false
})


// WEBPACK FOOTER //
// ./src/router/index.js